module.exports = __webpack_public_path__ + "img/2.63bc3faf.jpg";